import { useContext } from 'react';
import { useFormikContext } from 'formik';
import { InfoItem, Text } from '@intellecteu/common-ui';
import { isEmpty } from 'app/utils';
import { Labels } from 'app/constants';
import { ui } from 'ui/styles';
import { StepField, StepId, StepSection } from '../../../ui/form/multi/types';
import { StepperContext, TStepperContext } from '../../../ui/form/multi/context';
import { CustomErrorMessage } from '../../../ui/custom-error-message';

import s from './styles.module.scss';

interface StepSummaryProps {
  index: number;
  stepId: StepId;
  stepLabel: string;
  sections: StepSection[];
}

export const StepSummary = ({ index, stepId, stepLabel, sections }: StepSummaryProps) => {
  const { errors } = useFormikContext();
  const { hasStepError } = useContext<TStepperContext>(StepperContext);
  const hasError: boolean = hasStepError(stepId) && !isEmpty(errors);

  return (
    <div className={ui.mt20}>
      <Text
        className={hasError && s.errorTitle}
        color={hasError ? Text.color.error : Text.color.darkBlue}
        weight="bold"
        size="s"
      >
        Step {index + 1}: {stepLabel}
      </Text>

      {sections?.map((section: StepSection, sectionIdx: number) => (
        <div key={`${section.title}-${sectionIdx}`} className={s.stepSummary}>
          {section.title && (
            <Text size="s" weight="bold">
              {section.title}
            </Text>
          )}

          {section.fields.map(({ name, label, value }: StepField) => {
            if (String(value) && label) {
              return (
                <div key={name}>
                  <InfoItem
                    className={s.stepSummaryItem}
                    label={label}
                    value={String(value)}
                    style={
                      label === Labels.ONBOARD_SECRET || label === Labels.DEFAULT_JVM_OPTIONS
                        ? {
                            display: 'block',
                          }
                        : {}
                    }
                  />
                  <CustomErrorMessage name={name} />
                </div>
              );
            }

            return value ? (
              <div key={name}>
                <div>{value}</div>
                <CustomErrorMessage name={name} />
              </div>
            ) : null;
          })}
        </div>
      ))}
    </div>
  );
};
